export default __webpack_public_path__ + "static/media/deletePhoto.b6f4f678.png";